import { useAppSelector } from '../../../reducers';
import { currentSkuIdForProductSelector, productForSkuIdSelector } from '../../../selectors/ProductsSelectors';
import ProductLevelSelectionButton from './ProductLevelSelectionButton';
import UnavailableProductLevelButton from './UnavailableProductLevelButton';
import { jsx as _jsx } from "react/jsx-runtime";
const ProductLevelSelectionButtonContainer = ({
  productLine,
  productLevel,
  onClick,
  disabled,
  selected
}) => {
  const skuId = useAppSelector(state => currentSkuIdForProductSelector(state, {
    productLine,
    productLevel
  }));
  const apiName = useAppSelector(state => {
    const product = skuId ? productForSkuIdSelector(state, {
      skuId
    }) : null;
    return product === null || product === void 0 ? void 0 : product.apiName;
  });
  if (apiName && skuId) {
    return /*#__PURE__*/_jsx(ProductLevelSelectionButton, {
      "data-test-id": apiName,
      productLevel: productLevel,
      selected: selected,
      onClick: onClick,
      disabled: disabled,
      apiName: apiName
    });
  }
  return /*#__PURE__*/_jsx(UnavailableProductLevelButton, {});
};
export default ProductLevelSelectionButtonContainer;